import { useEffect, useState } from "react";
import { Container } from "@/components/site/primitives";

const KEY = "ordo-draft-markers";

export const PrototypeBar = () => {
  const [hidden, setHidden] = useState(() => window.localStorage.getItem(KEY) === "hidden");
  useEffect(() => {
    document.documentElement.dataset.drafts = hidden ? "hidden" : "shown";
    window.localStorage.setItem(KEY, hidden ? "hidden" : "shown");
  }, [hidden]);
  return (
    <div className="t-ink border-b border-o-line bg-[#05070b] text-o-text" data-testid="prototype-bar">
      <Container className="flex items-center justify-between gap-3 py-2 font-mono text-[10.5px] uppercase tracking-[0.16em]">
        <p className="text-o-dim">
          <span className="text-o-proof">Phase 1 · Structural prototype</span>
          <span className="hidden md:inline"> · Provisional wording and placeholder imagery · Not the final company website</span>
        </p>
        <button
          type="button"
          onClick={() => setHidden((h) => !h)}
          aria-pressed={!hidden}
          data-testid="toggle-draft-markers"
          className="shrink-0 border border-o-line px-2.5 py-1 text-o-dim transition-colors hover:border-o-proof hover:text-o-text"
        >
          Draft markers: {hidden ? "Hidden" : "Shown"}
        </button>
      </Container>
    </div>
  );
};
